export default {
  'Enter a promo code! First limit people receive amount coins':
    'Ange kampanjkod! Första gränsen folk får en summa mynt',
};
